__turbopack_context__.v({
  "body-20": "footer-cta-module-scss-module__klu1aa__body-20",
  "body-20--lg": "footer-cta-module-scss-module__klu1aa__body-20--lg",
  "body-20--md": "footer-cta-module-scss-module__klu1aa__body-20--md",
  "body-20--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__body-20--modal-button-layout-shift",
  "body-20--sm": "footer-cta-module-scss-module__klu1aa__body-20--sm",
  "body-20--tablet": "footer-cta-module-scss-module__klu1aa__body-20--tablet",
  "body-20--xl": "footer-cta-module-scss-module__klu1aa__body-20--xl",
  "body-20--xs": "footer-cta-module-scss-module__klu1aa__body-20--xs",
  "body-20--xxs": "footer-cta-module-scss-module__klu1aa__body-20--xxs",
  "body-2xl": "footer-cta-module-scss-module__klu1aa__body-2xl",
  "body-2xl--lg": "footer-cta-module-scss-module__klu1aa__body-2xl--lg",
  "body-2xl--md": "footer-cta-module-scss-module__klu1aa__body-2xl--md",
  "body-2xl--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__body-2xl--modal-button-layout-shift",
  "body-2xl--sm": "footer-cta-module-scss-module__klu1aa__body-2xl--sm",
  "body-2xl--tablet": "footer-cta-module-scss-module__klu1aa__body-2xl--tablet",
  "body-2xl--xl": "footer-cta-module-scss-module__klu1aa__body-2xl--xl",
  "body-2xl--xs": "footer-cta-module-scss-module__klu1aa__body-2xl--xs",
  "body-2xl--xxs": "footer-cta-module-scss-module__klu1aa__body-2xl--xxs",
  "body-2xs": "footer-cta-module-scss-module__klu1aa__body-2xs",
  "body-2xs--lg": "footer-cta-module-scss-module__klu1aa__body-2xs--lg",
  "body-2xs--md": "footer-cta-module-scss-module__klu1aa__body-2xs--md",
  "body-2xs--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__body-2xs--modal-button-layout-shift",
  "body-2xs--sm": "footer-cta-module-scss-module__klu1aa__body-2xs--sm",
  "body-2xs--tablet": "footer-cta-module-scss-module__klu1aa__body-2xs--tablet",
  "body-2xs--xl": "footer-cta-module-scss-module__klu1aa__body-2xs--xl",
  "body-2xs--xs": "footer-cta-module-scss-module__klu1aa__body-2xs--xs",
  "body-2xs--xxs": "footer-cta-module-scss-module__klu1aa__body-2xs--xxs",
  "body-3xl": "footer-cta-module-scss-module__klu1aa__body-3xl",
  "body-3xl--lg": "footer-cta-module-scss-module__klu1aa__body-3xl--lg",
  "body-3xl--md": "footer-cta-module-scss-module__klu1aa__body-3xl--md",
  "body-3xl--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__body-3xl--modal-button-layout-shift",
  "body-3xl--sm": "footer-cta-module-scss-module__klu1aa__body-3xl--sm",
  "body-3xl--tablet": "footer-cta-module-scss-module__klu1aa__body-3xl--tablet",
  "body-3xl--xl": "footer-cta-module-scss-module__klu1aa__body-3xl--xl",
  "body-3xl--xs": "footer-cta-module-scss-module__klu1aa__body-3xl--xs",
  "body-3xl--xxs": "footer-cta-module-scss-module__klu1aa__body-3xl--xxs",
  "body-3xs": "footer-cta-module-scss-module__klu1aa__body-3xs",
  "body-3xs--lg": "footer-cta-module-scss-module__klu1aa__body-3xs--lg",
  "body-3xs--md": "footer-cta-module-scss-module__klu1aa__body-3xs--md",
  "body-3xs--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__body-3xs--modal-button-layout-shift",
  "body-3xs--sm": "footer-cta-module-scss-module__klu1aa__body-3xs--sm",
  "body-3xs--tablet": "footer-cta-module-scss-module__klu1aa__body-3xs--tablet",
  "body-3xs--xl": "footer-cta-module-scss-module__klu1aa__body-3xs--xl",
  "body-3xs--xs": "footer-cta-module-scss-module__klu1aa__body-3xs--xs",
  "body-3xs--xxs": "footer-cta-module-scss-module__klu1aa__body-3xs--xxs",
  "body-lg": "footer-cta-module-scss-module__klu1aa__body-lg",
  "body-lg--lg": "footer-cta-module-scss-module__klu1aa__body-lg--lg",
  "body-lg--md": "footer-cta-module-scss-module__klu1aa__body-lg--md",
  "body-lg--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__body-lg--modal-button-layout-shift",
  "body-lg--sm": "footer-cta-module-scss-module__klu1aa__body-lg--sm",
  "body-lg--tablet": "footer-cta-module-scss-module__klu1aa__body-lg--tablet",
  "body-lg--xl": "footer-cta-module-scss-module__klu1aa__body-lg--xl",
  "body-lg--xs": "footer-cta-module-scss-module__klu1aa__body-lg--xs",
  "body-lg--xxs": "footer-cta-module-scss-module__klu1aa__body-lg--xxs",
  "body-md": "footer-cta-module-scss-module__klu1aa__body-md",
  "body-md--lg": "footer-cta-module-scss-module__klu1aa__body-md--lg",
  "body-md--md": "footer-cta-module-scss-module__klu1aa__body-md--md",
  "body-md--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__body-md--modal-button-layout-shift",
  "body-md--sm": "footer-cta-module-scss-module__klu1aa__body-md--sm",
  "body-md--tablet": "footer-cta-module-scss-module__klu1aa__body-md--tablet",
  "body-md--xl": "footer-cta-module-scss-module__klu1aa__body-md--xl",
  "body-md--xs": "footer-cta-module-scss-module__klu1aa__body-md--xs",
  "body-md--xxs": "footer-cta-module-scss-module__klu1aa__body-md--xxs",
  "body-xl": "footer-cta-module-scss-module__klu1aa__body-xl",
  "body-xl--lg": "footer-cta-module-scss-module__klu1aa__body-xl--lg",
  "body-xl--md": "footer-cta-module-scss-module__klu1aa__body-xl--md",
  "body-xl--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__body-xl--modal-button-layout-shift",
  "body-xl--sm": "footer-cta-module-scss-module__klu1aa__body-xl--sm",
  "body-xl--tablet": "footer-cta-module-scss-module__klu1aa__body-xl--tablet",
  "body-xl--xl": "footer-cta-module-scss-module__klu1aa__body-xl--xl",
  "body-xl--xs": "footer-cta-module-scss-module__klu1aa__body-xl--xs",
  "body-xl--xxs": "footer-cta-module-scss-module__klu1aa__body-xl--xxs",
  "body-xs": "footer-cta-module-scss-module__klu1aa__body-xs",
  "body-xs--lg": "footer-cta-module-scss-module__klu1aa__body-xs--lg",
  "body-xs--md": "footer-cta-module-scss-module__klu1aa__body-xs--md",
  "body-xs--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__body-xs--modal-button-layout-shift",
  "body-xs--sm": "footer-cta-module-scss-module__klu1aa__body-xs--sm",
  "body-xs--tablet": "footer-cta-module-scss-module__klu1aa__body-xs--tablet",
  "body-xs--xl": "footer-cta-module-scss-module__klu1aa__body-xs--xl",
  "body-xs--xs": "footer-cta-module-scss-module__klu1aa__body-xs--xs",
  "body-xs--xxs": "footer-cta-module-scss-module__klu1aa__body-xs--xxs",
  "container": "footer-cta-module-scss-module__klu1aa__container",
  "downloadApp": "footer-cta-module-scss-module__klu1aa__downloadApp",
  "heading-120": "footer-cta-module-scss-module__klu1aa__heading-120",
  "heading-120--lg": "footer-cta-module-scss-module__klu1aa__heading-120--lg",
  "heading-120--md": "footer-cta-module-scss-module__klu1aa__heading-120--md",
  "heading-120--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__heading-120--modal-button-layout-shift",
  "heading-120--sm": "footer-cta-module-scss-module__klu1aa__heading-120--sm",
  "heading-120--tablet": "footer-cta-module-scss-module__klu1aa__heading-120--tablet",
  "heading-120--xl": "footer-cta-module-scss-module__klu1aa__heading-120--xl",
  "heading-120--xs": "footer-cta-module-scss-module__klu1aa__heading-120--xs",
  "heading-120--xxs": "footer-cta-module-scss-module__klu1aa__heading-120--xxs",
  "heading-128": "footer-cta-module-scss-module__klu1aa__heading-128",
  "heading-128--lg": "footer-cta-module-scss-module__klu1aa__heading-128--lg",
  "heading-128--md": "footer-cta-module-scss-module__klu1aa__heading-128--md",
  "heading-128--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__heading-128--modal-button-layout-shift",
  "heading-128--sm": "footer-cta-module-scss-module__klu1aa__heading-128--sm",
  "heading-128--tablet": "footer-cta-module-scss-module__klu1aa__heading-128--tablet",
  "heading-128--xl": "footer-cta-module-scss-module__klu1aa__heading-128--xl",
  "heading-128--xs": "footer-cta-module-scss-module__klu1aa__heading-128--xs",
  "heading-128--xxs": "footer-cta-module-scss-module__klu1aa__heading-128--xxs",
  "heading-150": "footer-cta-module-scss-module__klu1aa__heading-150",
  "heading-150--lg": "footer-cta-module-scss-module__klu1aa__heading-150--lg",
  "heading-150--md": "footer-cta-module-scss-module__klu1aa__heading-150--md",
  "heading-150--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__heading-150--modal-button-layout-shift",
  "heading-150--sm": "footer-cta-module-scss-module__klu1aa__heading-150--sm",
  "heading-150--tablet": "footer-cta-module-scss-module__klu1aa__heading-150--tablet",
  "heading-150--xl": "footer-cta-module-scss-module__klu1aa__heading-150--xl",
  "heading-150--xs": "footer-cta-module-scss-module__klu1aa__heading-150--xs",
  "heading-150--xxs": "footer-cta-module-scss-module__klu1aa__heading-150--xxs",
  "heading-2xl": "footer-cta-module-scss-module__klu1aa__heading-2xl",
  "heading-2xl--lg": "footer-cta-module-scss-module__klu1aa__heading-2xl--lg",
  "heading-2xl--md": "footer-cta-module-scss-module__klu1aa__heading-2xl--md",
  "heading-2xl--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__heading-2xl--modal-button-layout-shift",
  "heading-2xl--sm": "footer-cta-module-scss-module__klu1aa__heading-2xl--sm",
  "heading-2xl--tablet": "footer-cta-module-scss-module__klu1aa__heading-2xl--tablet",
  "heading-2xl--xl": "footer-cta-module-scss-module__klu1aa__heading-2xl--xl",
  "heading-2xl--xs": "footer-cta-module-scss-module__klu1aa__heading-2xl--xs",
  "heading-2xl--xxs": "footer-cta-module-scss-module__klu1aa__heading-2xl--xxs",
  "heading-3xl": "footer-cta-module-scss-module__klu1aa__heading-3xl",
  "heading-3xl--lg": "footer-cta-module-scss-module__klu1aa__heading-3xl--lg",
  "heading-3xl--md": "footer-cta-module-scss-module__klu1aa__heading-3xl--md",
  "heading-3xl--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__heading-3xl--modal-button-layout-shift",
  "heading-3xl--sm": "footer-cta-module-scss-module__klu1aa__heading-3xl--sm",
  "heading-3xl--tablet": "footer-cta-module-scss-module__klu1aa__heading-3xl--tablet",
  "heading-3xl--xl": "footer-cta-module-scss-module__klu1aa__heading-3xl--xl",
  "heading-3xl--xs": "footer-cta-module-scss-module__klu1aa__heading-3xl--xs",
  "heading-3xl--xxs": "footer-cta-module-scss-module__klu1aa__heading-3xl--xxs",
  "heading-4xl": "footer-cta-module-scss-module__klu1aa__heading-4xl",
  "heading-4xl--lg": "footer-cta-module-scss-module__klu1aa__heading-4xl--lg",
  "heading-4xl--md": "footer-cta-module-scss-module__klu1aa__heading-4xl--md",
  "heading-4xl--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__heading-4xl--modal-button-layout-shift",
  "heading-4xl--sm": "footer-cta-module-scss-module__klu1aa__heading-4xl--sm",
  "heading-4xl--tablet": "footer-cta-module-scss-module__klu1aa__heading-4xl--tablet",
  "heading-4xl--xl": "footer-cta-module-scss-module__klu1aa__heading-4xl--xl",
  "heading-4xl--xs": "footer-cta-module-scss-module__klu1aa__heading-4xl--xs",
  "heading-4xl--xxs": "footer-cta-module-scss-module__klu1aa__heading-4xl--xxs",
  "heading-5xl": "footer-cta-module-scss-module__klu1aa__heading-5xl",
  "heading-5xl--lg": "footer-cta-module-scss-module__klu1aa__heading-5xl--lg",
  "heading-5xl--md": "footer-cta-module-scss-module__klu1aa__heading-5xl--md",
  "heading-5xl--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__heading-5xl--modal-button-layout-shift",
  "heading-5xl--sm": "footer-cta-module-scss-module__klu1aa__heading-5xl--sm",
  "heading-5xl--tablet": "footer-cta-module-scss-module__klu1aa__heading-5xl--tablet",
  "heading-5xl--xl": "footer-cta-module-scss-module__klu1aa__heading-5xl--xl",
  "heading-5xl--xs": "footer-cta-module-scss-module__klu1aa__heading-5xl--xs",
  "heading-5xl--xxs": "footer-cta-module-scss-module__klu1aa__heading-5xl--xxs",
  "heading-60": "footer-cta-module-scss-module__klu1aa__heading-60",
  "heading-60--lg": "footer-cta-module-scss-module__klu1aa__heading-60--lg",
  "heading-60--md": "footer-cta-module-scss-module__klu1aa__heading-60--md",
  "heading-60--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__heading-60--modal-button-layout-shift",
  "heading-60--sm": "footer-cta-module-scss-module__klu1aa__heading-60--sm",
  "heading-60--tablet": "footer-cta-module-scss-module__klu1aa__heading-60--tablet",
  "heading-60--xl": "footer-cta-module-scss-module__klu1aa__heading-60--xl",
  "heading-60--xs": "footer-cta-module-scss-module__klu1aa__heading-60--xs",
  "heading-60--xxs": "footer-cta-module-scss-module__klu1aa__heading-60--xxs",
  "heading-70": "footer-cta-module-scss-module__klu1aa__heading-70",
  "heading-70--lg": "footer-cta-module-scss-module__klu1aa__heading-70--lg",
  "heading-70--md": "footer-cta-module-scss-module__klu1aa__heading-70--md",
  "heading-70--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__heading-70--modal-button-layout-shift",
  "heading-70--sm": "footer-cta-module-scss-module__klu1aa__heading-70--sm",
  "heading-70--tablet": "footer-cta-module-scss-module__klu1aa__heading-70--tablet",
  "heading-70--xl": "footer-cta-module-scss-module__klu1aa__heading-70--xl",
  "heading-70--xs": "footer-cta-module-scss-module__klu1aa__heading-70--xs",
  "heading-70--xxs": "footer-cta-module-scss-module__klu1aa__heading-70--xxs",
  "heading-90": "footer-cta-module-scss-module__klu1aa__heading-90",
  "heading-90--lg": "footer-cta-module-scss-module__klu1aa__heading-90--lg",
  "heading-90--md": "footer-cta-module-scss-module__klu1aa__heading-90--md",
  "heading-90--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__heading-90--modal-button-layout-shift",
  "heading-90--sm": "footer-cta-module-scss-module__klu1aa__heading-90--sm",
  "heading-90--tablet": "footer-cta-module-scss-module__klu1aa__heading-90--tablet",
  "heading-90--xl": "footer-cta-module-scss-module__klu1aa__heading-90--xl",
  "heading-90--xs": "footer-cta-module-scss-module__klu1aa__heading-90--xs",
  "heading-90--xxs": "footer-cta-module-scss-module__klu1aa__heading-90--xxs",
  "heading-lg": "footer-cta-module-scss-module__klu1aa__heading-lg",
  "heading-lg--lg": "footer-cta-module-scss-module__klu1aa__heading-lg--lg",
  "heading-lg--md": "footer-cta-module-scss-module__klu1aa__heading-lg--md",
  "heading-lg--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__heading-lg--modal-button-layout-shift",
  "heading-lg--sm": "footer-cta-module-scss-module__klu1aa__heading-lg--sm",
  "heading-lg--tablet": "footer-cta-module-scss-module__klu1aa__heading-lg--tablet",
  "heading-lg--xl": "footer-cta-module-scss-module__klu1aa__heading-lg--xl",
  "heading-lg--xs": "footer-cta-module-scss-module__klu1aa__heading-lg--xs",
  "heading-lg--xxs": "footer-cta-module-scss-module__klu1aa__heading-lg--xxs",
  "heading-md": "footer-cta-module-scss-module__klu1aa__heading-md",
  "heading-md--lg": "footer-cta-module-scss-module__klu1aa__heading-md--lg",
  "heading-md--md": "footer-cta-module-scss-module__klu1aa__heading-md--md",
  "heading-md--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__heading-md--modal-button-layout-shift",
  "heading-md--sm": "footer-cta-module-scss-module__klu1aa__heading-md--sm",
  "heading-md--tablet": "footer-cta-module-scss-module__klu1aa__heading-md--tablet",
  "heading-md--xl": "footer-cta-module-scss-module__klu1aa__heading-md--xl",
  "heading-md--xs": "footer-cta-module-scss-module__klu1aa__heading-md--xs",
  "heading-md--xxs": "footer-cta-module-scss-module__klu1aa__heading-md--xxs",
  "heading-sm": "footer-cta-module-scss-module__klu1aa__heading-sm",
  "heading-sm--lg": "footer-cta-module-scss-module__klu1aa__heading-sm--lg",
  "heading-sm--md": "footer-cta-module-scss-module__klu1aa__heading-sm--md",
  "heading-sm--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__heading-sm--modal-button-layout-shift",
  "heading-sm--sm": "footer-cta-module-scss-module__klu1aa__heading-sm--sm",
  "heading-sm--tablet": "footer-cta-module-scss-module__klu1aa__heading-sm--tablet",
  "heading-sm--xl": "footer-cta-module-scss-module__klu1aa__heading-sm--xl",
  "heading-sm--xs": "footer-cta-module-scss-module__klu1aa__heading-sm--xs",
  "heading-sm--xxs": "footer-cta-module-scss-module__klu1aa__heading-sm--xxs",
  "heading-xl": "footer-cta-module-scss-module__klu1aa__heading-xl",
  "heading-xl--lg": "footer-cta-module-scss-module__klu1aa__heading-xl--lg",
  "heading-xl--md": "footer-cta-module-scss-module__klu1aa__heading-xl--md",
  "heading-xl--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__heading-xl--modal-button-layout-shift",
  "heading-xl--sm": "footer-cta-module-scss-module__klu1aa__heading-xl--sm",
  "heading-xl--tablet": "footer-cta-module-scss-module__klu1aa__heading-xl--tablet",
  "heading-xl--xl": "footer-cta-module-scss-module__klu1aa__heading-xl--xl",
  "heading-xl--xs": "footer-cta-module-scss-module__klu1aa__heading-xl--xs",
  "heading-xl--xxs": "footer-cta-module-scss-module__klu1aa__heading-xl--xxs",
  "heading-xs": "footer-cta-module-scss-module__klu1aa__heading-xs",
  "heading-xs--lg": "footer-cta-module-scss-module__klu1aa__heading-xs--lg",
  "heading-xs--md": "footer-cta-module-scss-module__klu1aa__heading-xs--md",
  "heading-xs--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__heading-xs--modal-button-layout-shift",
  "heading-xs--sm": "footer-cta-module-scss-module__klu1aa__heading-xs--sm",
  "heading-xs--tablet": "footer-cta-module-scss-module__klu1aa__heading-xs--tablet",
  "heading-xs--xl": "footer-cta-module-scss-module__klu1aa__heading-xs--xl",
  "heading-xs--xs": "footer-cta-module-scss-module__klu1aa__heading-xs--xs",
  "heading-xs--xxs": "footer-cta-module-scss-module__klu1aa__heading-xs--xxs",
  "heading-xxs": "footer-cta-module-scss-module__klu1aa__heading-xxs",
  "heading-xxs--lg": "footer-cta-module-scss-module__klu1aa__heading-xxs--lg",
  "heading-xxs--md": "footer-cta-module-scss-module__klu1aa__heading-xxs--md",
  "heading-xxs--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__heading-xxs--modal-button-layout-shift",
  "heading-xxs--sm": "footer-cta-module-scss-module__klu1aa__heading-xxs--sm",
  "heading-xxs--tablet": "footer-cta-module-scss-module__klu1aa__heading-xxs--tablet",
  "heading-xxs--xl": "footer-cta-module-scss-module__klu1aa__heading-xxs--xl",
  "heading-xxs--xs": "footer-cta-module-scss-module__klu1aa__heading-xxs--xs",
  "heading-xxs--xxs": "footer-cta-module-scss-module__klu1aa__heading-xxs--xxs",
  "large-prompt": "footer-cta-module-scss-module__klu1aa__large-prompt",
  "large-prompt--lg": "footer-cta-module-scss-module__klu1aa__large-prompt--lg",
  "large-prompt--md": "footer-cta-module-scss-module__klu1aa__large-prompt--md",
  "large-prompt--modal-button-layout-shift": "footer-cta-module-scss-module__klu1aa__large-prompt--modal-button-layout-shift",
  "large-prompt--sm": "footer-cta-module-scss-module__klu1aa__large-prompt--sm",
  "large-prompt--tablet": "footer-cta-module-scss-module__klu1aa__large-prompt--tablet",
  "large-prompt--xl": "footer-cta-module-scss-module__klu1aa__large-prompt--xl",
  "large-prompt--xs": "footer-cta-module-scss-module__klu1aa__large-prompt--xs",
  "large-prompt--xxs": "footer-cta-module-scss-module__klu1aa__large-prompt--xxs",
});
